/** Snapshot stored on production_completed history entries (backend). */
export interface JobCompletionDatesSnapshot {
  glass_arrival_date?: string | null;
  manufacture_date?: string | null;
  potential_delivery_date?: string | null;
}

export interface ProductionHistoryEntry {
  action?: string;
  moved_by_username?: string;
  moved_at?: string;
  completion_source?: string;
  dates_at_completion?: JobCompletionDatesSnapshot | null;
}

/**
 * Latest production completion done via Job Edit "Skip production" (for admin summary card).
 */
export function findLatestJobEditSkipCompletion(
  metadata: Record<string, unknown> | undefined | null
): ProductionHistoryEntry | null {
  const raw = metadata?.production_history;
  if (!Array.isArray(raw) || raw.length === 0) return null;
  for (let i = raw.length - 1; i >= 0; i--) {
    const e = raw[i] as ProductionHistoryEntry;
    if (e?.action === 'production_completed' && e?.completion_source === 'job_edit_skip') {
      return e;
    }
  }
  return null;
}
